import { Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewNotesData,
  setSelectedNotes,
  setSelectedRowNotes,
  setTableData,
} from "./action";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ViewNotes from "../PopUp/ViewNotes";
import ReactPaginate from "react-paginate";
import moment from "moment";
const rowStyle2 = (row, rowIndex) => {
  const style = {};
  style.backgroundColor = "#fff";
  return style;
};
// const tableData = [
//   { noteId: 1, category: "cat1", entity: "ent1", gstin: "29AAEPM1234" },
// ];
const Table = (props) => {
  const dispatch = useDispatch();
  const { selectedNotes, selectedRowNotes, tableData, totalPages } =
    useSelector((store) => store.notesReducer);
  const [openViewNote, setOpenViewNote] = useState(false);
  const [viewNotesId, setViewNotesId] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const handleViewNote = async (id, row) => {
    await dispatch(getViewNotesData(id));
    console.log("row::", row);
    setSelectedRow(row);
    setOpenViewNote(true);
    setViewNotesId(id);
  };
  const handleCloseViewNote = () => {
    setOpenViewNote(false);
  };
  const columns = [
    {
      dataField: "noteId",
      text: "Notes ID",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "11%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "category",
      text: "Category",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "11%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
      formatter: (cell, row) => {
        const categoryMap = {
          working_file: "Working File",
          filed_return: "Filed Return",
        };
        return categoryMap[row.category] || row.category;
      },
    },
    {
      dataField: "entityName",
      text: "Entity",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "9%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "gstin",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "12%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "periods",
      text: "Period",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "12%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
      formatter: (cell, row) => {
        const periods = row.periods;
        if (!periods || !Array.isArray(periods) || periods.length === 0) {
          return "-";
        }

        const monthMap = {
          "01": "Jan",
          "02": "Feb",
          "03": "Mar",
          "04": "Apr",
          "05": "May",
          "06": "Jun",
          "07": "Jul",
          "08": "Aug",
          "09": "Sep",
          10: "Oct",
          11: "Nov",
          12: "Dec",
        };

        // Sort periods to ensure proper order
        const sortedPeriods = periods.sort();
        const firstPeriod = sortedPeriods[0];
        const lastPeriod = sortedPeriods[sortedPeriods.length - 1];

        // Extract month and year from first and last periods
        const [firstMonth] = firstPeriod.split("-");
        const [lastMonth, year] = lastPeriod.split("-");

        const firstMonthName = monthMap[firstMonth];
        const lastMonthName = monthMap[lastMonth];

        // If same month, show only one month
        if (firstMonth === lastMonth) {
          return `${firstMonthName}`;
        }

        // Show range
        return `${firstMonthName}-${lastMonthName}`;
      },
    },
    {
      dataField: "fy",
      text: "Financial Year",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "11%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "createdDate",
      text: "Creation Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "13%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
      formatter: (col, row) => {
        return (
          <>
            {row?.createdDate
              ? moment(row.createdDate).format("DD/MM/YYYY HH:mm:ss")
              : "--"}
          </>
        );
      },
    },
    {
      dataField: "modifiedDate",
      text: "Last Modified Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "13%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
      formatter: (col, row) => {
        return (
          <>
            {row?.modifiedDate
              ? moment(row.modifiedDate).format("DD/MM/YYYY HH:mm:ss")
              : "--"}
          </>
        );
      },
    },
    {
      dataField: "view",
      text: "View",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const textWrap = "wrap";
        const wordBreak = "break-word";
        return {
          fontFamily,
          fontSize,
          fontWeight,
          textAlign,
          textWrap,
          wordBreak,
        };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "7%",
        textWrap: "wrap",
        wordBreak: "break-word",
        textAlign: "center",
      },
      formatter: (cell, row) => {
        return (
          <VisibilityIcon
            fontSize="small"
            onClick={() => handleViewNote(row.noteId, row)}
            style={{ cursor: "pointer" }}
          />
        );
      },
    },
  ];

  function handleOnSelect(row, isSelect) {
    if (isSelect) {
      dispatch(setSelectedNotes([...selectedNotes, row.noteId]));
      dispatch(setSelectedRowNotes([...selectedRowNotes, row]));
    } else {
      const updatedSelectedNotes = selectedNotes.filter(
        (id) => id !== row.noteId
      );
      dispatch(setSelectedNotes(updatedSelectedNotes));

      const updatedRows = selectedRowNotes.filter(
        (r) => r.noteId !== row.noteId
      );
      dispatch(setSelectedRowNotes(updatedRows));
    }
  }

  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.noteId);
    if (isSelect) {
      dispatch(setSelectedNotes(ids));
      dispatch(setSelectedRowNotes(rows));
    } else {
      dispatch(setSelectedNotes([]));
      dispatch(setSelectedRowNotes([]));
    }
  }

  const selectRow = {
    mode: "checkbox",
    selected: selectedNotes,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "1%",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "1%",
      textAlign: "center",
    },
  };

  // useEffect(() => {
  //   return () => {
  //     dispatch(setSelectedNotes([]));
  //     dispatch(setSelectedRowNotes([]));
  //     if (props.setSearch) {
  //       props.setSearch("");
  //     }
  //   };
  // }, [dispatch, props]);

  useEffect(() => {
    console.log("selectedNotes:", selectedNotes);
    console.log("selectedRowNotes:", selectedRowNotes);
  }, [selectedNotes, selectedRowNotes]);
  useEffect(() => {
    return () => {
      dispatch(setTableData([]));
    };
  }, []);

  return (
    <>
      {tableData?.length > 0 ? (
        <>
          <div
            className="light-border-notes-table"
            style={{ marginTop: "2em" }}
          >
            <BootstrapTable
              keyField="noteId"
              data={tableData}
              columns={columns}
              rowStyle={rowStyle2}
              selectRow={selectRow}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={props.pageNo - 1}
          />
          <ViewNotes
            open={openViewNote}
            onClose={handleCloseViewNote}
            viewNotesId={viewNotesId}
            selectedRow={selectedRow}
            handleSubmit={props.handleSubmit}
          />
        </>
      ) : (
        <div
          style={{
            height: "35vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography style={{ fontWeight: "800" }}>
            No Data Available
          </Typography>
        </div>
      )}
    </>
  );
};

export default Table;
